import { snapTileHeight } from './sliders.js';

export const SETTINGS_UNITS_UI = 'ui_pct_v1';

function clamp(value, min, max) {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return Number(min);
    if (numeric < min) return Number(min);
    if (numeric > max) return Number(max);
    return numeric;
}

function mapEngineReusePenaltyToUi(value) {
    const engineValue = clamp(value, 0, 1000);
    const normalized = engineValue / 1000;
    return Math.round(Math.sqrt(normalized) * 100);
}

export function normalizeSettingUnits(rawUnits) {
    const text = String(rawUnits || '').trim().toLowerCase();
    if (text === SETTINGS_UNITS_UI) return SETTINGS_UNITS_UI;
    return 'legacy';
}

export function toUiColorShare(value, rawUnits = '') {
    const units = normalizeSettingUnits(rawUnits);
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 50;
    if (units === SETTINGS_UNITS_UI) return Math.round(clamp(numeric, 0, 100));
    if (numeric <= 1) return Math.round(clamp(numeric * 100, 0, 100));
    return Math.round(clamp(numeric, 0, 100));
}

export function toUiNoiseFactor(value, rawUnits = '') {
    const units = normalizeSettingUnits(rawUnits);
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 0;
    if (units === SETTINGS_UNITS_UI) return Math.round(clamp(numeric, 0, 100));
    if (numeric <= 1) return Math.round(clamp(numeric * 100, 0, 100));
    return Math.round(clamp(numeric, 0, 100));
}

export function toUiReusePenalty(value, rawUnits = '') {
    const units = normalizeSettingUnits(rawUnits);
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return 45;
    if (units === SETTINGS_UNITS_UI) return Math.round(clamp(numeric, 0, 100));
    return mapEngineReusePenaltyToUi(numeric);
}

export function toUiTileHeight(value) {
    return snapTileHeight(clamp(value, 5, 160), 50);
}

export function toUiSettings(rawSettings = {}) {
    const settings = rawSettings && typeof rawSettings === 'object' ? rawSettings : {};
    const units = normalizeSettingUnits(settings.settings_units || settings.settingsUnits || '');
    return {
        ...settings,
        settings_units: SETTINGS_UNITS_UI,
        base_tile_height: toUiTileHeight(settings.base_tile_height),
        color_share: toUiColorShare(settings.color_share, units),
        noise_factor: toUiNoiseFactor(settings.noise_factor, units),
        reuse_penalty: toUiReusePenalty(settings.reuse_penalty, units),
    };
}
